"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               unknown
// source: rocketchat/api/relay_event.proto
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayEvent = exports.RelayTerminateVoiceChannelEvent = exports.RelayJoinVoiceChannelEvent = exports.RelayUpdateBubbleGroupEvent = exports.RelayRenewChannelEvent = exports.RelayLeaveMemberEvent = exports.RelayJoinMemberEvent = exports.RelayReadMessageEvent = exports.RelayUpdateMessageEvent = exports.RelayReplyEvent = exports.RelayUserMentionEvent = exports.CustomPush_DefaultValues = exports.CustomPush = exports.RelayNewMessageEvent = exports.RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason = exports.RelayLeaveMemberEvent_EventBy = exports.EventReason = exports.protobufPackage = void 0;
exports.eventReasonFromJSON = eventReasonFromJSON;
exports.eventReasonToJSON = eventReasonToJSON;
exports.eventReasonToNumber = eventReasonToNumber;
exports.relayLeaveMemberEvent_EventByFromJSON = relayLeaveMemberEvent_EventByFromJSON;
exports.relayLeaveMemberEvent_EventByToJSON = relayLeaveMemberEvent_EventByToJSON;
exports.relayLeaveMemberEvent_EventByToNumber = relayLeaveMemberEvent_EventByToNumber;
exports.relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonFromJSON = relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonFromJSON;
exports.relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonToJSON = relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonToJSON;
exports.relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonToNumber = relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonToNumber;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const timestamp_1 = require("../../google/protobuf/timestamp");
const model_1 = require("./model");
exports.protobufPackage = "api";
var EventReason;
(function (EventReason) {
    EventReason["EVENT_REASON_UNSPECIFIED"] = "EVENT_REASON_UNSPECIFIED";
    EventReason["EVENT_REASON_REACTION"] = "EVENT_REASON_REACTION";
})(EventReason || (exports.EventReason = EventReason = {}));
function eventReasonFromJSON(object) {
    switch (object) {
        case 0:
        case "EVENT_REASON_UNSPECIFIED":
            return EventReason.EVENT_REASON_UNSPECIFIED;
        case 1:
        case "EVENT_REASON_REACTION":
            return EventReason.EVENT_REASON_REACTION;
        default:
            return EventReason.EVENT_REASON_UNSPECIFIED;
    }
}
function eventReasonToJSON(object) {
    switch (object) {
        case EventReason.EVENT_REASON_UNSPECIFIED:
            return "EVENT_REASON_UNSPECIFIED";
        case EventReason.EVENT_REASON_REACTION:
            return "EVENT_REASON_REACTION";
        default:
            return "EVENT_REASON_UNSPECIFIED";
    }
}
function eventReasonToNumber(object) {
    switch (object) {
        case EventReason.EVENT_REASON_UNSPECIFIED:
            return 0;
        case EventReason.EVENT_REASON_REACTION:
            return 1;
        default:
            return 0;
    }
}
var RelayLeaveMemberEvent_EventBy;
(function (RelayLeaveMemberEvent_EventBy) {
    RelayLeaveMemberEvent_EventBy["EVENT_BY_SELF"] = "EVENT_BY_SELF";
    RelayLeaveMemberEvent_EventBy["EVENT_BY_OWNER"] = "EVENT_BY_OWNER";
    RelayLeaveMemberEvent_EventBy["EVENT_BY_ADMIN"] = "EVENT_BY_ADMIN";
})(RelayLeaveMemberEvent_EventBy || (exports.RelayLeaveMemberEvent_EventBy = RelayLeaveMemberEvent_EventBy = {}));
function relayLeaveMemberEvent_EventByFromJSON(object) {
    switch (object) {
        case 0:
        case "EVENT_BY_SELF":
            return RelayLeaveMemberEvent_EventBy.EVENT_BY_SELF;
        case 1:
        case "EVENT_BY_OWNER":
            return RelayLeaveMemberEvent_EventBy.EVENT_BY_OWNER;
        case 2:
        case "EVENT_BY_ADMIN":
            return RelayLeaveMemberEvent_EventBy.EVENT_BY_ADMIN;
        default:
            return RelayLeaveMemberEvent_EventBy.EVENT_BY_SELF;
    }
}
function relayLeaveMemberEvent_EventByToJSON(object) {
    switch (object) {
        case RelayLeaveMemberEvent_EventBy.EVENT_BY_SELF:
            return "EVENT_BY_SELF";
        case RelayLeaveMemberEvent_EventBy.EVENT_BY_OWNER:
            return "EVENT_BY_OWNER";
        case RelayLeaveMemberEvent_EventBy.EVENT_BY_ADMIN:
            return "EVENT_BY_ADMIN";
        default:
            return "EVENT_BY_SELF";
    }
}
function relayLeaveMemberEvent_EventByToNumber(object) {
    switch (object) {
        case RelayLeaveMemberEvent_EventBy.EVENT_BY_SELF:
            return 0;
        case RelayLeaveMemberEvent_EventBy.EVENT_BY_OWNER:
            return 1;
        case RelayLeaveMemberEvent_EventBy.EVENT_BY_ADMIN:
            return 2;
        default:
            return 0;
    }
}
var RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason;
(function (RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason) {
    RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason["TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED"] = "TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED";
    RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason["TERMINATE_VOICE_CHANNEL_REASON_BY_USER"] = "TERMINATE_VOICE_CHANNEL_REASON_BY_USER";
    RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason["TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING"] = "TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING";
    RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason["TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT"] = "TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT";
    RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason["TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED"] = "TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED";
})(RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason || (exports.RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason = RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason = {}));
function relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonFromJSON(object) {
    switch (object) {
        case 0:
        case "TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED":
            return RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED;
        case 1:
        case "TERMINATE_VOICE_CHANNEL_REASON_BY_USER":
            return RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_BY_USER;
        case 2:
        case "TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING":
            return RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING;
        case 3:
        case "TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT":
            return RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT;
        case 4:
        case "TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED":
            return RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED;
        default:
            return RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED;
    }
}
function relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonToJSON(object) {
    switch (object) {
        case RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED:
            return "TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED";
        case RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_BY_USER:
            return "TERMINATE_VOICE_CHANNEL_REASON_BY_USER";
        case RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING:
            return "TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING";
        case RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT:
            return "TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT";
        case RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED:
            return "TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED";
        default:
            return "TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED";
    }
}
function relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonToNumber(object) {
    switch (object) {
        case RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED:
            return 0;
        case RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_BY_USER:
            return 1;
        case RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_STATUS_CALLING:
            return 2;
        case RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TIMEOUT:
            return 3;
        case RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_PERMISSION_REQUIRED:
            return 4;
        default:
            return 0;
    }
}
function createBaseRelayNewMessageEvent() {
    return {
        channel_id: "",
        message_id: "0",
        session_id: "",
        content: "",
        sender_id: undefined,
        display_name: "",
        profile_image_url: "",
        readonly: false,
        message_type: "",
        template_type: undefined,
        thumbnail_image_url: undefined,
        resource_title: undefined,
        replied_user_id: undefined,
        mentioned_user_ids: [],
        custom_push: undefined,
        should_notification_mute: undefined,
        push_template_title: undefined,
        push_template_text: undefined,
        channel_type: undefined,
        resource_type: undefined,
        resource_id: undefined,
        create_time: undefined,
        skip_increase_unread_count: undefined,
    };
}
exports.RelayNewMessageEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        if (message.session_id !== "") {
            writer.uint32(26).string(message.session_id);
        }
        if (message.content !== "") {
            writer.uint32(34).string(message.content);
        }
        if (message.sender_id !== undefined) {
            model_1.UserID.encode(message.sender_id, writer.uint32(42).fork()).ldelim();
        }
        if (message.display_name !== "") {
            writer.uint32(58).string(message.display_name);
        }
        if (message.profile_image_url !== "") {
            writer.uint32(66).string(message.profile_image_url);
        }
        if (message.readonly !== false) {
            writer.uint32(72).bool(message.readonly);
        }
        if (message.message_type !== "") {
            writer.uint32(82).string(message.message_type);
        }
        if (message.template_type !== undefined) {
            writer.uint32(88).int32((0, model_1.templateTypeToNumber)(message.template_type));
        }
        if (message.thumbnail_image_url !== undefined) {
            writer.uint32(98).string(message.thumbnail_image_url);
        }
        if (message.resource_title !== undefined) {
            writer.uint32(106).string(message.resource_title);
        }
        if (message.replied_user_id !== undefined) {
            model_1.UserID.encode(message.replied_user_id, writer.uint32(114).fork())
                .ldelim();
        }
        for (const v of message.mentioned_user_ids) {
            model_1.UserID.encode(v, writer.uint32(122).fork()).ldelim();
        }
        if (message.custom_push !== undefined) {
            exports.CustomPush.encode(message.custom_push, writer.uint32(162).fork())
                .ldelim();
        }
        if (message.should_notification_mute !== undefined) {
            writer.uint32(168).bool(message.should_notification_mute);
        }
        if (message.push_template_title !== undefined) {
            writer.uint32(178).string(message.push_template_title);
        }
        if (message.push_template_text !== undefined) {
            writer.uint32(186).string(message.push_template_text);
        }
        if (message.channel_type !== undefined) {
            writer.uint32(192).int32(message.channel_type);
        }
        if (message.resource_type !== undefined) {
            writer.uint32(202).string(message.resource_type);
        }
        if (message.resource_id !== undefined) {
            writer.uint32(208).int64(message.resource_id);
        }
        if (message.create_time !== undefined) {
            timestamp_1.Timestamp.encode(message.create_time, writer.uint32(218).fork()).ldelim();
        }
        if (message.skip_increase_unread_count !== undefined) {
            writer.uint32(240).bool(message.skip_increase_unread_count);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayNewMessageEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.sender_id = model_1.UserID.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.display_name = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.profile_image_url = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.readonly = reader.bool();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.message_type = reader.string();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.template_type = (0, model_1.templateTypeFromJSON)(reader.int32());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.thumbnail_image_url = reader.string();
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.resource_title = reader.string();
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.replied_user_id = model_1.UserID.decode(reader, reader.uint32());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.mentioned_user_ids.push(model_1.UserID.decode(reader, reader.uint32()));
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.custom_push = exports.CustomPush.decode(reader, reader.uint32());
                    continue;
                case 21:
                    if (tag !== 168) {
                        break;
                    }
                    message.should_notification_mute = reader.bool();
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.push_template_title = reader.string();
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.push_template_text = reader.string();
                    continue;
                case 24:
                    if (tag !== 192) {
                        break;
                    }
                    message.channel_type = reader.int32();
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.resource_type = reader.string();
                    continue;
                case 26:
                    if (tag !== 208) {
                        break;
                    }
                    message.resource_id = longToString(reader.int64());
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.create_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 30:
                    if (tag !== 240) {
                        break;
                    }
                    message.skip_increase_unread_count = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            sender_id: isSet(object.sender_id)
                ? model_1.UserID.fromJSON(object.sender_id)
                : undefined,
            display_name: isSet(object.display_name)
                ? globalThis.String(object.display_name)
                : "",
            profile_image_url: isSet(object.profile_image_url)
                ? globalThis.String(object.profile_image_url)
                : "",
            readonly: isSet(object.readonly)
                ? globalThis.Boolean(object.readonly)
                : false,
            message_type: isSet(object.message_type)
                ? globalThis.String(object.message_type)
                : "",
            template_type: isSet(object.template_type)
                ? (0, model_1.templateTypeFromJSON)(object.template_type)
                : undefined,
            thumbnail_image_url: isSet(object.thumbnail_image_url)
                ? globalThis.String(object.thumbnail_image_url)
                : undefined,
            resource_title: isSet(object.resource_title)
                ? globalThis.String(object.resource_title)
                : undefined,
            replied_user_id: isSet(object.replied_user_id)
                ? model_1.UserID.fromJSON(object.replied_user_id)
                : undefined,
            mentioned_user_ids: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.mentioned_user_ids)
                ? object.mentioned_user_ids.map((e) => model_1.UserID.fromJSON(e))
                : [],
            custom_push: isSet(object.custom_push)
                ? exports.CustomPush.fromJSON(object.custom_push)
                : undefined,
            should_notification_mute: isSet(object.should_notification_mute)
                ? globalThis.Boolean(object.should_notification_mute)
                : undefined,
            push_template_title: isSet(object.push_template_title)
                ? globalThis.String(object.push_template_title)
                : undefined,
            push_template_text: isSet(object.push_template_text)
                ? globalThis.String(object.push_template_text)
                : undefined,
            channel_type: isSet(object.channel_type)
                ? globalThis.Number(object.channel_type)
                : undefined,
            resource_type: isSet(object.resource_type)
                ? globalThis.String(object.resource_type)
                : undefined,
            resource_id: isSet(object.resource_id)
                ? globalThis.String(object.resource_id)
                : undefined,
            create_time: isSet(object.create_time)
                ? fromJsonTimestamp(object.create_time)
                : undefined,
            skip_increase_unread_count: isSet(object.skip_increase_unread_count)
                ? globalThis.Boolean(object.skip_increase_unread_count)
                : undefined,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.sender_id !== undefined) {
            obj.sender_id = model_1.UserID.toJSON(message.sender_id);
        }
        if (message.display_name !== "") {
            obj.display_name = message.display_name;
        }
        if (message.profile_image_url !== "") {
            obj.profile_image_url = message.profile_image_url;
        }
        if (message.readonly !== false) {
            obj.readonly = message.readonly;
        }
        if (message.message_type !== "") {
            obj.message_type = message.message_type;
        }
        if (message.template_type !== undefined) {
            obj.template_type = (0, model_1.templateTypeToJSON)(message.template_type);
        }
        if (message.thumbnail_image_url !== undefined) {
            obj.thumbnail_image_url = message.thumbnail_image_url;
        }
        if (message.resource_title !== undefined) {
            obj.resource_title = message.resource_title;
        }
        if (message.replied_user_id !== undefined) {
            obj.replied_user_id = model_1.UserID.toJSON(message.replied_user_id);
        }
        if ((_a = message.mentioned_user_ids) === null || _a === void 0 ? void 0 : _a.length) {
            obj.mentioned_user_ids = message.mentioned_user_ids.map((e) => model_1.UserID.toJSON(e));
        }
        if (message.custom_push !== undefined) {
            obj.custom_push = exports.CustomPush.toJSON(message.custom_push);
        }
        if (message.should_notification_mute !== undefined) {
            obj.should_notification_mute = message.should_notification_mute;
        }
        if (message.push_template_title !== undefined) {
            obj.push_template_title = message.push_template_title;
        }
        if (message.push_template_text !== undefined) {
            obj.push_template_text = message.push_template_text;
        }
        if (message.channel_type !== undefined) {
            obj.channel_type = Math.round(message.channel_type);
        }
        if (message.resource_type !== undefined) {
            obj.resource_type = message.resource_type;
        }
        if (message.resource_id !== undefined) {
            obj.resource_id = message.resource_id;
        }
        if (message.create_time !== undefined) {
            obj.create_time = fromTimestamp(message.create_time).toISOString();
        }
        if (message.skip_increase_unread_count !== undefined) {
            obj.skip_increase_unread_count = message.skip_increase_unread_count;
        }
        return obj;
    },
    create(base) {
        return exports.RelayNewMessageEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        const message = createBaseRelayNewMessageEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        message.session_id = (_c = object.session_id) !== null && _c !== void 0 ? _c : "";
        message.content = (_d = object.content) !== null && _d !== void 0 ? _d : "";
        message.sender_id =
            (object.sender_id !== undefined && object.sender_id !== null)
                ? model_1.UserID.fromPartial(object.sender_id)
                : undefined;
        message.display_name = (_e = object.display_name) !== null && _e !== void 0 ? _e : "";
        message.profile_image_url = (_f = object.profile_image_url) !== null && _f !== void 0 ? _f : "";
        message.readonly = (_g = object.readonly) !== null && _g !== void 0 ? _g : false;
        message.message_type = (_h = object.message_type) !== null && _h !== void 0 ? _h : "";
        message.template_type = (_j = object.template_type) !== null && _j !== void 0 ? _j : undefined;
        message.thumbnail_image_url = (_k = object.thumbnail_image_url) !== null && _k !== void 0 ? _k : undefined;
        message.resource_title = (_l = object.resource_title) !== null && _l !== void 0 ? _l : undefined;
        message.replied_user_id =
            (object.replied_user_id !== undefined && object.replied_user_id !== null)
                ? model_1.UserID.fromPartial(object.replied_user_id)
                : undefined;
        message.mentioned_user_ids =
            ((_m = object.mentioned_user_ids) === null || _m === void 0 ? void 0 : _m.map((e) => model_1.UserID.fromPartial(e))) || [];
        message.custom_push =
            (object.custom_push !== undefined && object.custom_push !== null)
                ? exports.CustomPush.fromPartial(object.custom_push)
                : undefined;
        message.should_notification_mute = (_o = object.should_notification_mute) !== null && _o !== void 0 ? _o : undefined;
        message.push_template_title = (_p = object.push_template_title) !== null && _p !== void 0 ? _p : undefined;
        message.push_template_text = (_q = object.push_template_text) !== null && _q !== void 0 ? _q : undefined;
        message.channel_type = (_r = object.channel_type) !== null && _r !== void 0 ? _r : undefined;
        message.resource_type = (_s = object.resource_type) !== null && _s !== void 0 ? _s : undefined;
        message.resource_id = (_t = object.resource_id) !== null && _t !== void 0 ? _t : undefined;
        message.create_time =
            (object.create_time !== undefined && object.create_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.create_time)
                : undefined;
        message.skip_increase_unread_count = (_u = object.skip_increase_unread_count) !== null && _u !== void 0 ? _u : undefined;
        return message;
    },
};
function createBaseCustomPush() {
    return { template_format: "", default_values: undefined };
}
exports.CustomPush = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.template_format !== "") {
            writer.uint32(10).string(message.template_format);
        }
        if (message.default_values !== undefined) {
            exports.CustomPush_DefaultValues.encode(message.default_values, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCustomPush();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.template_format = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.default_values = exports.CustomPush_DefaultValues.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            template_format: isSet(object.template_format)
                ? globalThis.String(object.template_format)
                : "",
            default_values: isSet(object.default_values)
                ? exports.CustomPush_DefaultValues.fromJSON(object.default_values)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.template_format !== "") {
            obj.template_format = message.template_format;
        }
        if (message.default_values !== undefined) {
            obj.default_values = exports.CustomPush_DefaultValues.toJSON(message.default_values);
        }
        return obj;
    },
    create(base) {
        return exports.CustomPush.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCustomPush();
        message.template_format = (_a = object.template_format) !== null && _a !== void 0 ? _a : "";
        message.default_values =
            (object.default_values !== undefined && object.default_values !== null)
                ? exports.CustomPush_DefaultValues.fromPartial(object.default_values)
                : undefined;
        return message;
    },
};
function createBaseCustomPush_DefaultValues() {
    return {
        channel_title: "",
        resource_title: "",
        sender_nickname: "",
        message_content: "",
        template_message_title: "",
        template_message_text: "",
    };
}
exports.CustomPush_DefaultValues = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_title !== "") {
            writer.uint32(10).string(message.channel_title);
        }
        if (message.resource_title !== "") {
            writer.uint32(18).string(message.resource_title);
        }
        if (message.sender_nickname !== "") {
            writer.uint32(26).string(message.sender_nickname);
        }
        if (message.message_content !== "") {
            writer.uint32(34).string(message.message_content);
        }
        if (message.template_message_title !== "") {
            writer.uint32(42).string(message.template_message_title);
        }
        if (message.template_message_text !== "") {
            writer.uint32(50).string(message.template_message_text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCustomPush_DefaultValues();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_title = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.resource_title = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.sender_nickname = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.message_content = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.template_message_title = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.template_message_text = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_title: isSet(object.channel_title)
                ? globalThis.String(object.channel_title)
                : "",
            resource_title: isSet(object.resource_title)
                ? globalThis.String(object.resource_title)
                : "",
            sender_nickname: isSet(object.sender_nickname)
                ? globalThis.String(object.sender_nickname)
                : "",
            message_content: isSet(object.message_content)
                ? globalThis.String(object.message_content)
                : "",
            template_message_title: isSet(object.template_message_title)
                ? globalThis.String(object.template_message_title)
                : "",
            template_message_text: isSet(object.template_message_text)
                ? globalThis.String(object.template_message_text)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_title !== "") {
            obj.channel_title = message.channel_title;
        }
        if (message.resource_title !== "") {
            obj.resource_title = message.resource_title;
        }
        if (message.sender_nickname !== "") {
            obj.sender_nickname = message.sender_nickname;
        }
        if (message.message_content !== "") {
            obj.message_content = message.message_content;
        }
        if (message.template_message_title !== "") {
            obj.template_message_title = message.template_message_title;
        }
        if (message.template_message_text !== "") {
            obj.template_message_text = message.template_message_text;
        }
        return obj;
    },
    create(base) {
        return exports.CustomPush_DefaultValues.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseCustomPush_DefaultValues();
        message.channel_title = (_a = object.channel_title) !== null && _a !== void 0 ? _a : "";
        message.resource_title = (_b = object.resource_title) !== null && _b !== void 0 ? _b : "";
        message.sender_nickname = (_c = object.sender_nickname) !== null && _c !== void 0 ? _c : "";
        message.message_content = (_d = object.message_content) !== null && _d !== void 0 ? _d : "";
        message.template_message_title = (_e = object.template_message_title) !== null && _e !== void 0 ? _e : "";
        message.template_message_text = (_f = object.template_message_text) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
function createBaseRelayUserMentionEvent() {
    return {
        channel_id: "",
        message_id: "0",
        session_id: "",
        content: "",
        sender_id: undefined,
        display_name: "",
        profile_image_url: "",
        mute: false,
        silence: false,
        target_uri: "",
        resource_title: undefined,
    };
}
exports.RelayUserMentionEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        if (message.session_id !== "") {
            writer.uint32(26).string(message.session_id);
        }
        if (message.content !== "") {
            writer.uint32(34).string(message.content);
        }
        if (message.sender_id !== undefined) {
            model_1.UserID.encode(message.sender_id, writer.uint32(42).fork()).ldelim();
        }
        if (message.display_name !== "") {
            writer.uint32(58).string(message.display_name);
        }
        if (message.profile_image_url !== "") {
            writer.uint32(66).string(message.profile_image_url);
        }
        if (message.mute !== false) {
            writer.uint32(72).bool(message.mute);
        }
        if (message.silence !== false) {
            writer.uint32(80).bool(message.silence);
        }
        if (message.target_uri !== "") {
            writer.uint32(90).string(message.target_uri);
        }
        if (message.resource_title !== undefined) {
            writer.uint32(98).string(message.resource_title);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayUserMentionEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.sender_id = model_1.UserID.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.display_name = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.profile_image_url = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.mute = reader.bool();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.silence = reader.bool();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.resource_title = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            sender_id: isSet(object.sender_id)
                ? model_1.UserID.fromJSON(object.sender_id)
                : undefined,
            display_name: isSet(object.display_name)
                ? globalThis.String(object.display_name)
                : "",
            profile_image_url: isSet(object.profile_image_url)
                ? globalThis.String(object.profile_image_url)
                : "",
            mute: isSet(object.mute) ? globalThis.Boolean(object.mute) : false,
            silence: isSet(object.silence)
                ? globalThis.Boolean(object.silence)
                : false,
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
            resource_title: isSet(object.resource_title)
                ? globalThis.String(object.resource_title)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.sender_id !== undefined) {
            obj.sender_id = model_1.UserID.toJSON(message.sender_id);
        }
        if (message.display_name !== "") {
            obj.display_name = message.display_name;
        }
        if (message.profile_image_url !== "") {
            obj.profile_image_url = message.profile_image_url;
        }
        if (message.mute !== false) {
            obj.mute = message.mute;
        }
        if (message.silence !== false) {
            obj.silence = message.silence;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        if (message.resource_title !== undefined) {
            obj.resource_title = message.resource_title;
        }
        return obj;
    },
    create(base) {
        return exports.RelayUserMentionEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const message = createBaseRelayUserMentionEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        message.session_id = (_c = object.session_id) !== null && _c !== void 0 ? _c : "";
        message.content = (_d = object.content) !== null && _d !== void 0 ? _d : "";
        message.sender_id =
            (object.sender_id !== undefined && object.sender_id !== null)
                ? model_1.UserID.fromPartial(object.sender_id)
                : undefined;
        message.display_name = (_e = object.display_name) !== null && _e !== void 0 ? _e : "";
        message.profile_image_url = (_f = object.profile_image_url) !== null && _f !== void 0 ? _f : "";
        message.mute = (_g = object.mute) !== null && _g !== void 0 ? _g : false;
        message.silence = (_h = object.silence) !== null && _h !== void 0 ? _h : false;
        message.target_uri = (_j = object.target_uri) !== null && _j !== void 0 ? _j : "";
        message.resource_title = (_k = object.resource_title) !== null && _k !== void 0 ? _k : undefined;
        return message;
    },
};
function createBaseRelayReplyEvent() {
    return {
        channel_id: "",
        message_id: "0",
        session_id: "",
        content: "",
        sender_id: undefined,
        display_name: "",
        profile_image_url: "",
        mute: false,
        readonly: false,
        target_uri: "",
        resource_title: undefined,
    };
}
exports.RelayReplyEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        if (message.session_id !== "") {
            writer.uint32(26).string(message.session_id);
        }
        if (message.content !== "") {
            writer.uint32(34).string(message.content);
        }
        if (message.sender_id !== undefined) {
            model_1.UserID.encode(message.sender_id, writer.uint32(42).fork()).ldelim();
        }
        if (message.display_name !== "") {
            writer.uint32(58).string(message.display_name);
        }
        if (message.profile_image_url !== "") {
            writer.uint32(66).string(message.profile_image_url);
        }
        if (message.mute !== false) {
            writer.uint32(72).bool(message.mute);
        }
        if (message.readonly !== false) {
            writer.uint32(80).bool(message.readonly);
        }
        if (message.target_uri !== "") {
            writer.uint32(90).string(message.target_uri);
        }
        if (message.resource_title !== undefined) {
            writer.uint32(98).string(message.resource_title);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayReplyEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.sender_id = model_1.UserID.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.display_name = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.profile_image_url = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.mute = reader.bool();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.readonly = reader.bool();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.resource_title = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            sender_id: isSet(object.sender_id)
                ? model_1.UserID.fromJSON(object.sender_id)
                : undefined,
            display_name: isSet(object.display_name)
                ? globalThis.String(object.display_name)
                : "",
            profile_image_url: isSet(object.profile_image_url)
                ? globalThis.String(object.profile_image_url)
                : "",
            mute: isSet(object.mute) ? globalThis.Boolean(object.mute) : false,
            readonly: isSet(object.readonly)
                ? globalThis.Boolean(object.readonly)
                : false,
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
            resource_title: isSet(object.resource_title)
                ? globalThis.String(object.resource_title)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.sender_id !== undefined) {
            obj.sender_id = model_1.UserID.toJSON(message.sender_id);
        }
        if (message.display_name !== "") {
            obj.display_name = message.display_name;
        }
        if (message.profile_image_url !== "") {
            obj.profile_image_url = message.profile_image_url;
        }
        if (message.mute !== false) {
            obj.mute = message.mute;
        }
        if (message.readonly !== false) {
            obj.readonly = message.readonly;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        if (message.resource_title !== undefined) {
            obj.resource_title = message.resource_title;
        }
        return obj;
    },
    create(base) {
        return exports.RelayReplyEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const message = createBaseRelayReplyEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        message.session_id = (_c = object.session_id) !== null && _c !== void 0 ? _c : "";
        message.content = (_d = object.content) !== null && _d !== void 0 ? _d : "";
        message.sender_id =
            (object.sender_id !== undefined && object.sender_id !== null)
                ? model_1.UserID.fromPartial(object.sender_id)
                : undefined;
        message.display_name = (_e = object.display_name) !== null && _e !== void 0 ? _e : "";
        message.profile_image_url = (_f = object.profile_image_url) !== null && _f !== void 0 ? _f : "";
        message.mute = (_g = object.mute) !== null && _g !== void 0 ? _g : false;
        message.readonly = (_h = object.readonly) !== null && _h !== void 0 ? _h : false;
        message.target_uri = (_j = object.target_uri) !== null && _j !== void 0 ? _j : "";
        message.resource_title = (_k = object.resource_title) !== null && _k !== void 0 ? _k : undefined;
        return message;
    },
};
function createBaseRelayUpdateMessageEvent() {
    return {
        channel_id: "",
        message_id: "0",
        session_id: "",
        reason: EventReason.EVENT_REASON_UNSPECIFIED,
    };
}
exports.RelayUpdateMessageEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        if (message.session_id !== "") {
            writer.uint32(26).string(message.session_id);
        }
        if (message.reason !== EventReason.EVENT_REASON_UNSPECIFIED) {
            writer.uint32(32).int32(eventReasonToNumber(message.reason));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayUpdateMessageEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.reason = eventReasonFromJSON(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
            reason: isSet(object.reason)
                ? eventReasonFromJSON(object.reason)
                : EventReason.EVENT_REASON_UNSPECIFIED,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        if (message.reason !== EventReason.EVENT_REASON_UNSPECIFIED) {
            obj.reason = eventReasonToJSON(message.reason);
        }
        return obj;
    },
    create(base) {
        return exports.RelayUpdateMessageEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseRelayUpdateMessageEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        message.session_id = (_c = object.session_id) !== null && _c !== void 0 ? _c : "";
        message.reason = (_d = object.reason) !== null && _d !== void 0 ? _d : EventReason.EVENT_REASON_UNSPECIFIED;
        return message;
    },
};
function createBaseRelayReadMessageEvent() {
    return {
        channel_id: "",
        message_id: "0",
        reader_id: undefined,
        session_id: "",
    };
}
exports.RelayReadMessageEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        if (message.reader_id !== undefined) {
            model_1.UserID.encode(message.reader_id, writer.uint32(26).fork()).ldelim();
        }
        if (message.session_id !== "") {
            writer.uint32(34).string(message.session_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayReadMessageEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.reader_id = model_1.UserID.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            reader_id: isSet(object.reader_id)
                ? model_1.UserID.fromJSON(object.reader_id)
                : undefined,
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.reader_id !== undefined) {
            obj.reader_id = model_1.UserID.toJSON(message.reader_id);
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        return obj;
    },
    create(base) {
        return exports.RelayReadMessageEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseRelayReadMessageEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        message.reader_id =
            (object.reader_id !== undefined && object.reader_id !== null)
                ? model_1.UserID.fromPartial(object.reader_id)
                : undefined;
        message.session_id = (_c = object.session_id) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseRelayJoinMemberEvent() {
    return {
        channel_id: "",
        join_member: undefined,
        session_id: "",
        member_count: 0,
        event_time: undefined,
    };
}
exports.RelayJoinMemberEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.join_member !== undefined) {
            model_1.User.encode(message.join_member, writer.uint32(18).fork()).ldelim();
        }
        if (message.session_id !== "") {
            writer.uint32(26).string(message.session_id);
        }
        if (message.member_count !== 0) {
            writer.uint32(32).int32(message.member_count);
        }
        if (message.event_time !== undefined) {
            timestamp_1.Timestamp.encode(message.event_time, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayJoinMemberEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.join_member = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.member_count = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.event_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            join_member: isSet(object.join_member)
                ? model_1.User.fromJSON(object.join_member)
                : undefined,
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
            member_count: isSet(object.member_count)
                ? globalThis.Number(object.member_count)
                : 0,
            event_time: isSet(object.event_time)
                ? fromJsonTimestamp(object.event_time)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.join_member !== undefined) {
            obj.join_member = model_1.User.toJSON(message.join_member);
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        if (message.member_count !== 0) {
            obj.member_count = Math.round(message.member_count);
        }
        if (message.event_time !== undefined) {
            obj.event_time = fromTimestamp(message.event_time).toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.RelayJoinMemberEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseRelayJoinMemberEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.join_member =
            (object.join_member !== undefined && object.join_member !== null)
                ? model_1.User.fromPartial(object.join_member)
                : undefined;
        message.session_id = (_b = object.session_id) !== null && _b !== void 0 ? _b : "";
        message.member_count = (_c = object.member_count) !== null && _c !== void 0 ? _c : 0;
        message.event_time =
            (object.event_time !== undefined && object.event_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.event_time)
                : undefined;
        return message;
    },
};
function createBaseRelayLeaveMemberEvent() {
    return {
        channel_id: "",
        session_id: "",
        leave_member_id: undefined,
        nickname: "",
        by: RelayLeaveMemberEvent_EventBy.EVENT_BY_SELF,
        member_count: 0,
        event_time: undefined,
    };
}
exports.RelayLeaveMemberEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.session_id !== "") {
            writer.uint32(18).string(message.session_id);
        }
        if (message.leave_member_id !== undefined) {
            model_1.UserID.encode(message.leave_member_id, writer.uint32(26).fork()).ldelim();
        }
        if (message.nickname !== "") {
            writer.uint32(34).string(message.nickname);
        }
        if (message.by !== RelayLeaveMemberEvent_EventBy.EVENT_BY_SELF) {
            writer.uint32(40).int32(relayLeaveMemberEvent_EventByToNumber(message.by));
        }
        if (message.member_count !== 0) {
            writer.uint32(48).int32(message.member_count);
        }
        if (message.event_time !== undefined) {
            timestamp_1.Timestamp.encode(message.event_time, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayLeaveMemberEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.leave_member_id = model_1.UserID.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.nickname = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.by = relayLeaveMemberEvent_EventByFromJSON(reader.int32());
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.member_count = reader.int32();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.event_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
            leave_member_id: isSet(object.leave_member_id)
                ? model_1.UserID.fromJSON(object.leave_member_id)
                : undefined,
            nickname: isSet(object.nickname)
                ? globalThis.String(object.nickname)
                : "",
            by: isSet(object.by)
                ? relayLeaveMemberEvent_EventByFromJSON(object.by)
                : RelayLeaveMemberEvent_EventBy.EVENT_BY_SELF,
            member_count: isSet(object.member_count)
                ? globalThis.Number(object.member_count)
                : 0,
            event_time: isSet(object.event_time)
                ? fromJsonTimestamp(object.event_time)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        if (message.leave_member_id !== undefined) {
            obj.leave_member_id = model_1.UserID.toJSON(message.leave_member_id);
        }
        if (message.nickname !== "") {
            obj.nickname = message.nickname;
        }
        if (message.by !== RelayLeaveMemberEvent_EventBy.EVENT_BY_SELF) {
            obj.by = relayLeaveMemberEvent_EventByToJSON(message.by);
        }
        if (message.member_count !== 0) {
            obj.member_count = Math.round(message.member_count);
        }
        if (message.event_time !== undefined) {
            obj.event_time = fromTimestamp(message.event_time).toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.RelayLeaveMemberEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseRelayLeaveMemberEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.session_id = (_b = object.session_id) !== null && _b !== void 0 ? _b : "";
        message.leave_member_id =
            (object.leave_member_id !== undefined && object.leave_member_id !== null)
                ? model_1.UserID.fromPartial(object.leave_member_id)
                : undefined;
        message.nickname = (_c = object.nickname) !== null && _c !== void 0 ? _c : "";
        message.by = (_d = object.by) !== null && _d !== void 0 ? _d : RelayLeaveMemberEvent_EventBy.EVENT_BY_SELF;
        message.member_count = (_e = object.member_count) !== null && _e !== void 0 ? _e : 0;
        message.event_time =
            (object.event_time !== undefined && object.event_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.event_time)
                : undefined;
        return message;
    },
};
function createBaseRelayRenewChannelEvent() {
    return { channel_id: "", session_id: "" };
}
exports.RelayRenewChannelEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.session_id !== "") {
            writer.uint32(18).string(message.session_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayRenewChannelEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        return obj;
    },
    create(base) {
        return exports.RelayRenewChannelEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRelayRenewChannelEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.session_id = (_b = object.session_id) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseRelayUpdateBubbleGroupEvent() {
    return { channel_id: "", session_id: "", bubble_group: undefined };
}
exports.RelayUpdateBubbleGroupEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.session_id !== "") {
            writer.uint32(18).string(message.session_id);
        }
        if (message.bubble_group !== undefined) {
            model_1.BubbleGroup.encode(message.bubble_group, writer.uint32(26).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayUpdateBubbleGroupEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.session_id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.bubble_group = model_1.BubbleGroup.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            session_id: isSet(object.session_id)
                ? globalThis.String(object.session_id)
                : "",
            bubble_group: isSet(object.bubble_group)
                ? model_1.BubbleGroup.fromJSON(object.bubble_group)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.session_id !== "") {
            obj.session_id = message.session_id;
        }
        if (message.bubble_group !== undefined) {
            obj.bubble_group = model_1.BubbleGroup.toJSON(message.bubble_group);
        }
        return obj;
    },
    create(base) {
        return exports.RelayUpdateBubbleGroupEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRelayUpdateBubbleGroupEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.session_id = (_b = object.session_id) !== null && _b !== void 0 ? _b : "";
        message.bubble_group =
            (object.bubble_group !== undefined && object.bubble_group !== null)
                ? model_1.BubbleGroup.fromPartial(object.bubble_group)
                : undefined;
        return message;
    },
};
function createBaseRelayJoinVoiceChannelEvent() {
    return { channel_id: "", user_id: undefined };
}
exports.RelayJoinVoiceChannelEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.user_id !== undefined) {
            model_1.UserID.encode(message.user_id, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayJoinVoiceChannelEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.user_id = model_1.UserID.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            user_id: isSet(object.user_id)
                ? model_1.UserID.fromJSON(object.user_id)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.user_id !== undefined) {
            obj.user_id = model_1.UserID.toJSON(message.user_id);
        }
        return obj;
    },
    create(base) {
        return exports.RelayJoinVoiceChannelEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseRelayJoinVoiceChannelEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.user_id = (object.user_id !== undefined && object.user_id !== null)
            ? model_1.UserID.fromPartial(object.user_id)
            : undefined;
        return message;
    },
};
function createBaseRelayTerminateVoiceChannelEvent() {
    return {
        channel_id: "",
        reason: RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED,
    };
}
exports.RelayTerminateVoiceChannelEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.reason !==
            RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED) {
            writer.uint32(16).int32(relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonToNumber(message.reason));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayTerminateVoiceChannelEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.reason =
                        relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonFromJSON(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            reason: isSet(object.reason)
                ? relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonFromJSON(object.reason)
                : RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
                    .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.reason !==
            RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED) {
            obj.reason =
                relayTerminateVoiceChannelEvent_TerminateVoiceChannelReasonToJSON(message.reason);
        }
        return obj;
    },
    create(base) {
        return exports.RelayTerminateVoiceChannelEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRelayTerminateVoiceChannelEvent();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.reason = (_b = object.reason) !== null && _b !== void 0 ? _b : RelayTerminateVoiceChannelEvent_TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED;
        return message;
    },
};
function createBaseRelayEvent() {
    return {
        is_push_required: false,
        is_badge_sync_required: false,
        relay_new_message_event: undefined,
        relay_user_mention_event: undefined,
        relay_reply_event: undefined,
        relay_update_message_event: undefined,
        relay_read_message_event: undefined,
        relay_join_member_event: undefined,
        relay_leave_member_event: undefined,
        relay_renew_channel_event: undefined,
        relay_update_bubble_group_event: undefined,
        relay_join_voice_channel_event: undefined,
        relay_terminate_voice_channel_event: undefined,
    };
}
exports.RelayEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.is_push_required !== false) {
            writer.uint32(8).bool(message.is_push_required);
        }
        if (message.is_badge_sync_required !== false) {
            writer.uint32(16).bool(message.is_badge_sync_required);
        }
        if (message.relay_new_message_event !== undefined) {
            exports.RelayNewMessageEvent.encode(message.relay_new_message_event, writer.uint32(242).fork()).ldelim();
        }
        if (message.relay_user_mention_event !== undefined) {
            exports.RelayUserMentionEvent.encode(message.relay_user_mention_event, writer.uint32(250).fork()).ldelim();
        }
        if (message.relay_reply_event !== undefined) {
            exports.RelayReplyEvent.encode(message.relay_reply_event, writer.uint32(258).fork()).ldelim();
        }
        if (message.relay_update_message_event !== undefined) {
            exports.RelayUpdateMessageEvent.encode(message.relay_update_message_event, writer.uint32(266).fork()).ldelim();
        }
        if (message.relay_read_message_event !== undefined) {
            exports.RelayReadMessageEvent.encode(message.relay_read_message_event, writer.uint32(274).fork()).ldelim();
        }
        if (message.relay_join_member_event !== undefined) {
            exports.RelayJoinMemberEvent.encode(message.relay_join_member_event, writer.uint32(282).fork()).ldelim();
        }
        if (message.relay_leave_member_event !== undefined) {
            exports.RelayLeaveMemberEvent.encode(message.relay_leave_member_event, writer.uint32(290).fork()).ldelim();
        }
        if (message.relay_renew_channel_event !== undefined) {
            exports.RelayRenewChannelEvent.encode(message.relay_renew_channel_event, writer.uint32(298).fork()).ldelim();
        }
        if (message.relay_update_bubble_group_event !== undefined) {
            exports.RelayUpdateBubbleGroupEvent.encode(message.relay_update_bubble_group_event, writer.uint32(306).fork()).ldelim();
        }
        if (message.relay_join_voice_channel_event !== undefined) {
            exports.RelayJoinVoiceChannelEvent.encode(message.relay_join_voice_channel_event, writer.uint32(314).fork()).ldelim();
        }
        if (message.relay_terminate_voice_channel_event !== undefined) {
            exports.RelayTerminateVoiceChannelEvent.encode(message.relay_terminate_voice_channel_event, writer.uint32(322).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRelayEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.is_push_required = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.is_badge_sync_required = reader.bool();
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.relay_new_message_event = exports.RelayNewMessageEvent.decode(reader, reader.uint32());
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.relay_user_mention_event = exports.RelayUserMentionEvent.decode(reader, reader.uint32());
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.relay_reply_event = exports.RelayReplyEvent.decode(reader, reader.uint32());
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.relay_update_message_event = exports.RelayUpdateMessageEvent.decode(reader, reader.uint32());
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.relay_read_message_event = exports.RelayReadMessageEvent.decode(reader, reader.uint32());
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.relay_join_member_event = exports.RelayJoinMemberEvent.decode(reader, reader.uint32());
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.relay_leave_member_event = exports.RelayLeaveMemberEvent.decode(reader, reader.uint32());
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.relay_renew_channel_event = exports.RelayRenewChannelEvent.decode(reader, reader.uint32());
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.relay_update_bubble_group_event = exports.RelayUpdateBubbleGroupEvent
                        .decode(reader, reader.uint32());
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.relay_join_voice_channel_event = exports.RelayJoinVoiceChannelEvent
                        .decode(reader, reader.uint32());
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.relay_terminate_voice_channel_event =
                        exports.RelayTerminateVoiceChannelEvent.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            is_push_required: isSet(object.is_push_required)
                ? globalThis.Boolean(object.is_push_required)
                : false,
            is_badge_sync_required: isSet(object.is_badge_sync_required)
                ? globalThis.Boolean(object.is_badge_sync_required)
                : false,
            relay_new_message_event: isSet(object.relay_new_message_event)
                ? exports.RelayNewMessageEvent.fromJSON(object.relay_new_message_event)
                : undefined,
            relay_user_mention_event: isSet(object.relay_user_mention_event)
                ? exports.RelayUserMentionEvent.fromJSON(object.relay_user_mention_event)
                : undefined,
            relay_reply_event: isSet(object.relay_reply_event)
                ? exports.RelayReplyEvent.fromJSON(object.relay_reply_event)
                : undefined,
            relay_update_message_event: isSet(object.relay_update_message_event)
                ? exports.RelayUpdateMessageEvent.fromJSON(object.relay_update_message_event)
                : undefined,
            relay_read_message_event: isSet(object.relay_read_message_event)
                ? exports.RelayReadMessageEvent.fromJSON(object.relay_read_message_event)
                : undefined,
            relay_join_member_event: isSet(object.relay_join_member_event)
                ? exports.RelayJoinMemberEvent.fromJSON(object.relay_join_member_event)
                : undefined,
            relay_leave_member_event: isSet(object.relay_leave_member_event)
                ? exports.RelayLeaveMemberEvent.fromJSON(object.relay_leave_member_event)
                : undefined,
            relay_renew_channel_event: isSet(object.relay_renew_channel_event)
                ? exports.RelayRenewChannelEvent.fromJSON(object.relay_renew_channel_event)
                : undefined,
            relay_update_bubble_group_event: isSet(object.relay_update_bubble_group_event)
                ? exports.RelayUpdateBubbleGroupEvent.fromJSON(object.relay_update_bubble_group_event)
                : undefined,
            relay_join_voice_channel_event: isSet(object.relay_join_voice_channel_event)
                ? exports.RelayJoinVoiceChannelEvent.fromJSON(object.relay_join_voice_channel_event)
                : undefined,
            relay_terminate_voice_channel_event: isSet(object.relay_terminate_voice_channel_event)
                ? exports.RelayTerminateVoiceChannelEvent.fromJSON(object.relay_terminate_voice_channel_event)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.is_push_required !== false) {
            obj.is_push_required = message.is_push_required;
        }
        if (message.is_badge_sync_required !== false) {
            obj.is_badge_sync_required = message.is_badge_sync_required;
        }
        if (message.relay_new_message_event !== undefined) {
            obj.relay_new_message_event = exports.RelayNewMessageEvent.toJSON(message.relay_new_message_event);
        }
        if (message.relay_user_mention_event !== undefined) {
            obj.relay_user_mention_event = exports.RelayUserMentionEvent.toJSON(message.relay_user_mention_event);
        }
        if (message.relay_reply_event !== undefined) {
            obj.relay_reply_event = exports.RelayReplyEvent.toJSON(message.relay_reply_event);
        }
        if (message.relay_update_message_event !== undefined) {
            obj.relay_update_message_event = exports.RelayUpdateMessageEvent.toJSON(message.relay_update_message_event);
        }
        if (message.relay_read_message_event !== undefined) {
            obj.relay_read_message_event = exports.RelayReadMessageEvent.toJSON(message.relay_read_message_event);
        }
        if (message.relay_join_member_event !== undefined) {
            obj.relay_join_member_event = exports.RelayJoinMemberEvent.toJSON(message.relay_join_member_event);
        }
        if (message.relay_leave_member_event !== undefined) {
            obj.relay_leave_member_event = exports.RelayLeaveMemberEvent.toJSON(message.relay_leave_member_event);
        }
        if (message.relay_renew_channel_event !== undefined) {
            obj.relay_renew_channel_event = exports.RelayRenewChannelEvent.toJSON(message.relay_renew_channel_event);
        }
        if (message.relay_update_bubble_group_event !== undefined) {
            obj.relay_update_bubble_group_event = exports.RelayUpdateBubbleGroupEvent.toJSON(message.relay_update_bubble_group_event);
        }
        if (message.relay_join_voice_channel_event !== undefined) {
            obj.relay_join_voice_channel_event = exports.RelayJoinVoiceChannelEvent.toJSON(message.relay_join_voice_channel_event);
        }
        if (message.relay_terminate_voice_channel_event !== undefined) {
            obj.relay_terminate_voice_channel_event = exports.RelayTerminateVoiceChannelEvent
                .toJSON(message.relay_terminate_voice_channel_event);
        }
        return obj;
    },
    create(base) {
        return exports.RelayEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRelayEvent();
        message.is_push_required = (_a = object.is_push_required) !== null && _a !== void 0 ? _a : false;
        message.is_badge_sync_required = (_b = object.is_badge_sync_required) !== null && _b !== void 0 ? _b : false;
        message.relay_new_message_event =
            (object.relay_new_message_event !== undefined &&
                object.relay_new_message_event !== null)
                ? exports.RelayNewMessageEvent.fromPartial(object.relay_new_message_event)
                : undefined;
        message.relay_user_mention_event =
            (object.relay_user_mention_event !== undefined &&
                object.relay_user_mention_event !== null)
                ? exports.RelayUserMentionEvent.fromPartial(object.relay_user_mention_event)
                : undefined;
        message.relay_reply_event = (object.relay_reply_event !== undefined &&
            object.relay_reply_event !== null)
            ? exports.RelayReplyEvent.fromPartial(object.relay_reply_event)
            : undefined;
        message.relay_update_message_event =
            (object.relay_update_message_event !== undefined &&
                object.relay_update_message_event !== null)
                ? exports.RelayUpdateMessageEvent.fromPartial(object.relay_update_message_event)
                : undefined;
        message.relay_read_message_event =
            (object.relay_read_message_event !== undefined &&
                object.relay_read_message_event !== null)
                ? exports.RelayReadMessageEvent.fromPartial(object.relay_read_message_event)
                : undefined;
        message.relay_join_member_event =
            (object.relay_join_member_event !== undefined &&
                object.relay_join_member_event !== null)
                ? exports.RelayJoinMemberEvent.fromPartial(object.relay_join_member_event)
                : undefined;
        message.relay_leave_member_event =
            (object.relay_leave_member_event !== undefined &&
                object.relay_leave_member_event !== null)
                ? exports.RelayLeaveMemberEvent.fromPartial(object.relay_leave_member_event)
                : undefined;
        message.relay_renew_channel_event =
            (object.relay_renew_channel_event !== undefined &&
                object.relay_renew_channel_event !== null)
                ? exports.RelayRenewChannelEvent.fromPartial(object.relay_renew_channel_event)
                : undefined;
        message.relay_update_bubble_group_event =
            (object.relay_update_bubble_group_event !== undefined &&
                object.relay_update_bubble_group_event !== null)
                ? exports.RelayUpdateBubbleGroupEvent.fromPartial(object.relay_update_bubble_group_event)
                : undefined;
        message.relay_join_voice_channel_event =
            (object.relay_join_voice_channel_event !== undefined &&
                object.relay_join_voice_channel_event !== null)
                ? exports.RelayJoinVoiceChannelEvent.fromPartial(object.relay_join_voice_channel_event)
                : undefined;
        message.relay_terminate_voice_channel_event =
            (object.relay_terminate_voice_channel_event !== undefined &&
                object.relay_terminate_voice_channel_event !== null)
                ? exports.RelayTerminateVoiceChannelEvent.fromPartial(object.relay_terminate_voice_channel_event)
                : undefined;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (globalThis.Number(t.seconds) || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new globalThis.Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
